import OPSCChatbot from './OPSCChatbot';

export default function App() {
  return (
    <div style={{
      minHeight: '100vh',
      background: '#F0F2F5',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
    }}>
      <OPSCChatbot />
    </div>
  );
}
